import { atom, selector } from 'recoil'

import { activeModelState } from './activeModel'

export const mapOverlays = atom({
  key: 'mapOverlays',
  default: selector({
    key: 'mapOverlaysFromActiveModel',
    get: ({ get }) => {
      const { mapOverlays = [] } = get(activeModelState)
      return mapOverlays
    },
  }),
})
